import { jsx as _jsx } from "react/jsx-runtime";
import { HistoryOutlinedIcon, NotepadFilledIcon, PersonFilledIcon, RecordingTapeFilledIcon, } from '@getgo/chameleon-icons/react';
import ContactToolbar from "../ContactToolbar";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
export var CallOverlayContactToolbarTab;
(function (CallOverlayContactToolbarTab) {
    CallOverlayContactToolbarTab["CONTACT_INFORMATION"] = "call-overlay-contact-information-tab";
    CallOverlayContactToolbarTab["AUDIO_RECORDINGS"] = "call-overlay-audio-recordings-tab";
    CallOverlayContactToolbarTab["NOTES"] = "call-overlay-notes-tab";
    CallOverlayContactToolbarTab["HISTORY"] = "call-overlay-history-tab";
    CallOverlayContactToolbarTab["NONE"] = "";
})(CallOverlayContactToolbarTab || (CallOverlayContactToolbarTab = {}));
const CallOverlayContactToolbar = ({ hasContactInfo, hasRecordings, hasNotes, hasHistory, selected = CallOverlayContactToolbarTab.NONE, onChange, }) => {
    const { t } = useTranslation();
    const getToolbarButtons = () => {
        const buttons = [];
        if (hasContactInfo) {
            buttons.push({
                id: CallOverlayContactToolbarTab.CONTACT_INFORMATION,
                label: t('Contact information'),
                icon: _jsx(PersonFilledIcon, {}, void 0),
            });
        }
        if (hasRecordings) {
            buttons.push({
                id: CallOverlayContactToolbarTab.AUDIO_RECORDINGS,
                label: t('Audio recordings'),
                icon: _jsx(RecordingTapeFilledIcon, {}, void 0),
            });
        }
        if (hasNotes) {
            buttons.push({
                id: CallOverlayContactToolbarTab.NOTES,
                label: t('Notes'),
                icon: _jsx(NotepadFilledIcon, {}, void 0),
            });
        }
        if (hasHistory) {
            buttons.push({
                id: CallOverlayContactToolbarTab.HISTORY,
                label: t('History'),
                icon: _jsx(HistoryOutlinedIcon, {}, void 0),
            });
        }
        return buttons;
    };
    const [toolbarButtons, setToolbarButtons] = useState(() => getToolbarButtons());
    useEffect(() => {
        setToolbarButtons(getToolbarButtons());
    }, [hasContactInfo, hasRecordings, hasNotes, hasHistory]);
    return (_jsx(ContactToolbar, { toolbarButtons: toolbarButtons, selected: selected, onChange: onChange, size: "medium" }, void 0));
};
export default CallOverlayContactToolbar;
//# sourceMappingURL=index.js.map